import { Component, OnInit, Input } from '@angular/core';
import { PayPeriod } from 'projects/app-misc/src/app/modules/punch-time-widget/data/pay-period';
import { TimeCardService } from 'projects/app-misc/src/app/modules/punch-time-widget/data/time-card.service';
import moment from 'moment';
import { ReportCard } from 'projects/app-misc/src/app/modules/punch-time-widget/data/report-data/report-card';
import { TotalByProject } from 'projects/app-misc/src/app/modules/punch-time-widget/data/totalByProject';
import { Editions } from 'projects/app-misc/src/app/modules/punch-time-widget/data/report-data/editions';

@Component({
    selector: 'app-additional-report-info',
    templateUrl: './additional-report-info.component.html',
    styleUrls: ['./additional-report-info.component.scss']
})
export class AdditionalReportInfoComponent implements OnInit {
    @Input()
    payPeriod: PayPeriod;

    @Input()
    reportCard: ReportCard;

    overtimes: TotalByProject[] = [];

    timeCardChanges: ReportCard[];

  @Input()
    editions: Editions[] = [];

    constructor(
        protected timeCardService: TimeCardService
    ) { }

    ngOnInit(): void {
        this.reportCard.weeks.filter(week => week.overtime > 0).forEach(week => {
            this.overtimes.push({
                name: `${moment(week.start).format('MMM DD')} - ${moment(week.finish).format('MMM DD')}`,
                total: week.overtime
            })
        })
    }

}
